import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Game } from '../../../Core'

/**
 *  Pop up showed when you have finished the game
 */
class FinishedGamePopUp extends React.Component {
  /**
   *  Component constructor.
   */
  constructor(props) {
    super(props)
  }

  /**
   * Close the pop up and never shows it again
   */
  closePopUp() {
    const { removePopup } = this.props

    removePopup('finished_game')
  }

  /**
   *  Render Component.
   */
  render() {
    return (
      <div className="popup--background popup--puzzle">
        <div className="popup popup--error">
          <h2 className={'h2'}>
            <FormattedMessage id="popups.endGamePrompt.title" />
          </h2>
          <div className="list-item">
            <FormattedMessage id="popups.endGamePopUp.message" />
          </div>
          <div className="btn btn--secondary" onClick={() => this.closePopUp()}>
            <FormattedMessage id="popups.endGamePopUp.goToDocuments" />
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    removePopup: bindActionCreators(Game.actions.removePopup, dispatch),
  }
}

FinishedGamePopUp.propTypes = {
  removePopup: PropTypes.func,
}

export default connect(null, mapDispatchToProps)(FinishedGamePopUp)
